import { useMemo, type ReactNode } from 'react';
import { MessagingProvider } from '@gokrew/ui';
import { tokenManager } from '@/auth';
import { createMessagingApi, messagingSocketUrl } from '@/api/messaging';
import { useAuth } from '@/context/AuthContext';
export const MessagingSession = ({ children }: { children: ReactNode }) => {
  const { companyId, user } = useAuth();
  const userId = user?.id;
  const api = useMemo(() => createMessagingApi(companyId ?? ''), [companyId]);
  return (
    <MessagingProvider
      key={`${companyId}:${userId}`}
      api={api}
      companyId={companyId}
      userId={userId}
      portal="company"
      socketUrl={messagingSocketUrl()}
      getToken={tokenManager.getValidToken}
      refreshToken={tokenManager.forceRefresh}
    >
      {children}
    </MessagingProvider>
  );
};
